import type { LocalStorageKeyEntry } from "./helper";
import { prefix } from "./helper";

export type UseLocalStorageKeysKeys =
  | "atAccountFavorites"
  | "atAccountHistory"
  | "atExperimentEnablement"
  | "atCameFromAdminReferrer"
  | "ddcAccountFavorites"
  | "ddcAccountHistory"
  | "ddcAccountSearchHistory"
  | "ddcAccountSearchHistoryEnable"
  | "ddcAccountSearchFavorites"
  | "ddcAccountSearchFavoritesEnable"
  | "ddcAccountSearchPinFilters"
  | "ddcPagesClientSearchPageSize"
  | "ddcPagesDashboardShowOnlyChecked"
  | "ddcPagesDashboardShowOnlyConfigurable"
  | "dealerCenterWelcomeMessageLastClosed"
  | "ddcExperimentEnablement"
  | "incentivesManagerTableAttributes";

// Single source of truth for all local storage keys
export const localStorageKeys: Record<
  UseLocalStorageKeysKeys,
  LocalStorageKeyEntry
> = {
  atAccountFavorites: {
    value: prefix + "autotrader-account-favourites",
    description: "List of accounts marked as favourites in autotrader",
    maxLength: 200
  },
  atAccountHistory: {
    value: prefix + "autotrader-account-history",
    description: "List of most recently viewed accounts in autotrader",
    maxLength: 20
  },
  atExperimentEnablement: {
    value: prefix + "autotrader-experiment-enablement",
    description: "AT Experiments"
  },
  atCameFromAdminReferrer: {
    value: prefix + "autotrader-came-from-admin-referrer",
    description:
      "Whether this dealersite session first arrived from the admin domain, captured because document.referrer is lost on any later reload/typed-URL navigation"
  },
  ddcAccountFavorites: {
    value: prefix + "account-favourites",
    description: "List of accounts marked as favourites",
    maxLength: 200
  },
  ddcAccountHistory: {
    value: prefix + "account-history",
    description: "List of most recently viewed accounts",
    maxLength: 20
  },
  ddcAccountSearchHistory: {
    value: prefix + "account-search-history",
    description: "List of most recent searches",
    maxLength: 20
  },
  ddcAccountSearchHistoryEnable: {
    value: prefix + "account-search-history-enable",
    description: "Should account history display"
  },
  ddcAccountSearchFavorites: {
    value: prefix + "account-search-favourites",
    description: "List of favourite searches",
    maxLength: 20
  },
  ddcAccountSearchFavoritesEnable: {
    value: prefix + "account-search-favourites-enable",
    description: "Should account search favourites display"
  },
  ddcAccountSearchPinFilters: {
    value: prefix + "account-search-pin-filters",
    description: "Should the account search filters be pinned"
  },
  ddcPagesClientSearchPageSize: {
    value: prefix + "pages-client-search-pageSize",
    description: "How many results to show on client search"
  },
  ddcPagesDashboardShowOnlyChecked: {
    value: prefix + "pages-dashboard-showOnlyChecked",
    description: "Should only checked items be shown on the resources dashboard"
  },
  ddcPagesDashboardShowOnlyConfigurable: {
    value: prefix + "pages-dashboard-showOnlyConfigurable",
    description:
      "Should only configurable items be shown on the resources dashboard"
  },
  dealerCenterWelcomeMessageLastClosed: {
    value: prefix + "show-dealer-center-welcome-message",
    description: "When was the dealer center welcome message last closed"
  },
  ddcExperimentEnablement: {
    value: prefix + "ddc-experiment-enablement",
    description: "DDC Experiments"
  },
  incentivesManagerTableAttributes: {
    value: prefix + "incentives-manager-table-attributes",
    description: "Attributes for the incentives manager table"
  }
} as const;
